import { useCallback } from 'react';

const FOOTER_LINKS = [
  {
    title: '剧集分类',
    links: ['国产剧', '海外剧', '古装剧', '都市剧', '悬疑剧'],
  },
  {
    title: '快捷入口',
    links: ['热播榜单', '最新更新', '剧集专题', '精彩推荐', '追剧快讯'],
  },
  {
    title: '关于我们',
    links: ['平台介绍', '联系我们', '常见问题', '用户协议', '隐私政策'],
  },
];

export default function Footer() {
  const scrollToAnchor = useCallback((href: string) => {
    const target = document.querySelector(href);
    if (target) {
      const headerHeight = 64;
      const top = target.getBoundingClientRect().top + window.pageYOffset - headerHeight;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  }, []);

  const linkMap: Record<string, string> = {
    '国产剧': '#index',
    '海外剧': '#index',
    '古装剧': '#index',
    '都市剧': '#index',
    '悬疑剧': '#index',
    '热播榜单': '#ranking',
    '最新更新': '#updates',
    '剧集专题': '#index',
    '精彩推荐': '#carousel',
    '追剧快讯': '#updates',
    '平台介绍': '#about',
    '联系我们': '#contact',
    '常见问题': '#faq',
  };

  return (
    <footer id="footer" className="bg-secondary-900 text-background-50/80">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12">
            {/* Brand */}
            <div className="col-span-2 md:col-span-1">
              <a href="#hero" className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                  <i className="ri-movie-2-line text-background-50 text-lg"></i>
                </div>
                <span className="font-heading text-xl font-bold text-background-50 whitespace-nowrap">
                  桔子影院
                </span>
              </a>
              <p className="text-sm text-background-50/50 leading-relaxed mb-4">
                提供海量电视剧全集完整剧集，涵盖国产剧、海外剧全季资源，免费在线畅享高清不缓冲追剧体验。
              </p>
              <div className="flex items-center gap-3">
                <a href="#contact" onClick={(e) => { e.preventDefault(); scrollToAnchor('#contact'); }} className="w-8 h-8 rounded-full bg-background-50/10 hover:bg-primary-500 flex items-center justify-center transition-colors cursor-pointer">
                  <i className="ri-wechat-line text-sm text-background-50/70"></i>
                </a>
                <a href="#contact" onClick={(e) => { e.preventDefault(); scrollToAnchor('#contact'); }} className="w-8 h-8 rounded-full bg-background-50/10 hover:bg-primary-500 flex items-center justify-center transition-colors cursor-pointer">
                  <i className="ri-mail-line text-sm text-background-50/70"></i>
                </a>
              </div>
            </div>

            {/* Link columns */}
            {FOOTER_LINKS.map((col) => (
              <div key={col.title}>
                <h4 className="font-heading text-sm font-semibold text-background-50 mb-4 whitespace-nowrap">
                  {col.title}
                </h4>
                <ul className="space-y-2.5">
                  {col.links.map((link) => {
                    const href = linkMap[link];
                    if (href) {
                      return (
                        <li key={link}>
                          <a
                            href={href}
                            onClick={(e) => { e.preventDefault(); scrollToAnchor(href); }}
                            className="text-sm text-background-50/50 hover:text-accent-400 transition-colors cursor-pointer whitespace-nowrap"
                          >
                            {link}
                          </a>
                        </li>
                      );
                    }
                    return (
                      <li key={link}>
                        <span className="text-sm text-background-50/50 whitespace-nowrap">{link}</span>
                      </li>
                    );
                  })}
                </ul>
              </div>
            ))}
          </div>

          {/* Partners */}
          <div className="mt-12 pt-8 border-t border-background-50/10">
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-3">
              合作伙伴
            </h4>
            <p className="text-sm text-background-50/40">
              敬请期待更多合作伙伴加入
            </p>
          </div>

          {/* Copyright */}
          <div className="mt-8 pt-6 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-background-50/40">
              &copy; {new Date().getFullYear()} 桔子影院. 本站内容仅供学习交流，请支持正版.
            </p>
            <p className="text-xs text-background-50/40">
              国产剧海外剧高清不缓冲追剧 — 桔子影院
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}